"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldMap = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _striptags = _interopRequireDefault(require("striptags"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _entities = _interopRequireDefault(require("./entities.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fieldMap = exports.fieldMap = {
  en: 'entityIdEn',
  es: 'entityIdEs'
};
function TopLevelEntityTable(props) {
  var _currValues, _currValues2, _currValues3, _currValues4, _currValues5, _currValues6;
  // in Pinned Content form, this is a secondary formik bag
  // in Modules form, this is the top-level formik bag
  var isModuleField = !!props.isModuleField;
  var prefix = props.prefix || '';
  var assignmentData = props.assignmentData,
    label = props.label,
    subFormikBag = props.subFormikBag;
  var assignmentId = (0, _get2["default"])(assignmentData, 'assignmentId', -1);
  var buildLanguages = (0, _get2["default"])(assignmentData, 'settings.buildLanguages', []) || [];
  var isEnglish = buildLanguages.includes('en');
  var isSpanish = buildLanguages.includes('es');
  var currValues = {};
  var currErrEn = '';
  var currErrEs = '';
  if (isModuleField) {
    currValues = (0, _get2["default"])(subFormikBag.values, "".concat(prefix), {});
    currErrEn = subFormikBag.submitCount > 0 ? (0, _get2["default"])(subFormikBag.errors, "".concat(prefix, ".entityIdEn"), '') : '';
    currErrEs = subFormikBag.submitCount > 0 ? (0, _get2["default"])(subFormikBag.errors, "".concat(prefix, ".entityIdEs"), '') : '';
  } else {
    var _subFormikBag$errors, _subFormikBag$errors2;
    currValues = subFormikBag.values || {};
    currErrEn = subFormikBag.submitCount > 0 && ((_subFormikBag$errors = subFormikBag.errors) === null || _subFormikBag$errors === void 0 ? void 0 : _subFormikBag$errors.entityIdEn);
    currErrEs = subFormikBag.submitCount > 0 && ((_subFormikBag$errors2 = subFormikBag.errors) === null || _subFormikBag$errors2 === void 0 ? void 0 : _subFormikBag$errors2.entityIdEs);
  }
  function handleRowClick(lang, row) {
    var curr = (0, _get2["default"])(currValues, fieldMap[lang]);
    if (curr === row.entityId) {
      return;
    }
    var needsScroll = !curr;
    var newValue = _objectSpread(_objectSpread({}, currValues), {}, _defineProperty({}, fieldMap[lang], row.entityId));
    if (isModuleField) {
      subFormikBag.setFieldValue(prefix, newValue);
    } else {
      newValue.surveyHandle = row['flow.survey.surveyHandle'];
      subFormikBag.setValues(newValue);
    }

    // Make sure user sees the additional settings below table, when selecting resource for first time
    if (needsScroll) {
      setTimeout(function () {
        var settingsEl = document.getElementById('moreSettings');
        if (settingsEl) {
          settingsEl.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 300);
    }
  }
  function handleSetRowClass(lang, row) {
    var curr = (0, _get2["default"])(currValues, fieldMap[lang]);
    if (curr && row.entityId === curr) {
      return 'table-primary';
    }
    return _style["default"].unstyled;
  }
  function renderContent(_ref) {
    var row = _ref.row;
    var displayName = '';
    if (row['content.name']) {
      displayName = row['content.name'];
    } else if (row['content.text']) {
      displayName = (0, _striptags["default"])(row['content.text']);
    }
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].contentColumn
    }, displayName.substring(0, 29));
  }
  var commonTableProps = {
    maxSelectableRows: 1,
    noRecordsMessage: 'No survey elements are available to select',
    perPage: 10,
    query: _entities["default"],
    rowKey: 'entityId',
    striped: false,
    columns: [{
      name: 'entityId',
      label: 'ID',
      sort: true,
      filter: true,
      width: '60px'
    }, {
      name: 'flow.survey.label',
      label: 'Survey',
      sort: true,
      filter: true
    }, {
      name: 'type',
      label: 'Type',
      sort: true,
      filter: true
    }, {
      name: 'content.name',
      label: 'Content',
      sort: false,
      filter: false,
      render: renderContent,
      width: '300px'
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tables
  }, isEnglish && /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: currErrEn ? _style["default"].labelErr : ''
  }, isSpanish && /*#__PURE__*/_react["default"].createElement("span", null, "(ENGLISH)\xA0"), label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].topLevelEntityTable, " ").concat(currErrEn ? _style["default"].tableErr : '')
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], _extends({}, commonTableProps, {
    filter: (_currValues = currValues) !== null && _currValues !== void 0 && _currValues.entityIdEn ? {
      entityId: ((_currValues2 = currValues) === null || _currValues2 === void 0 ? void 0 : _currValues2.entityIdEn) + ''
    } : null,
    graphqlVariables: {
      language: 'en',
      assignmentId: assignmentId
    },
    name: "topLevelEntitiesEn",
    onRowClick: function onRowClick(row) {
      return handleRowClick('en', row);
    },
    selectedRows: (_currValues3 = currValues) !== null && _currValues3 !== void 0 && _currValues3.entityIdEn ? [currValues.entityIdEn] : [],
    setRowClass: function setRowClass(row) {
      return handleSetRowClass('en', row);
    }
  })), currErrEn && /*#__PURE__*/_react["default"].createElement("p", {
    className: 'text-danger ' + _style["default"].errMsg
  }, currErrEn)))), isSpanish && /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: currErrEs ? _style["default"].labelErr : ''
  }, isEnglish && /*#__PURE__*/_react["default"].createElement("span", null, "(SPANISH)\xA0"), label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].topLevelEntityTable, " ").concat(currErrEs ? _style["default"].tableErr : '')
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], _extends({}, commonTableProps, {
    filter: (_currValues4 = currValues) !== null && _currValues4 !== void 0 && _currValues4.entityIdEs ? {
      entityId: ((_currValues5 = currValues) === null || _currValues5 === void 0 ? void 0 : _currValues5.entityIdEs) + ''
    } : null,
    graphqlVariables: {
      language: 'es',
      assignmentId: assignmentId
    },
    name: "topLevelEntitiesEs",
    onRowClick: function onRowClick(row) {
      return handleRowClick('es', row);
    },
    selectedRows: (_currValues6 = currValues) !== null && _currValues6 !== void 0 && _currValues6.entityIdEs ? [currValues.entityIdEs] : [],
    setRowClass: function setRowClass(row) {
      return handleSetRowClass('es', row);
    }
  })), currErrEs && /*#__PURE__*/_react["default"].createElement("p", {
    className: 'text-danger ' + _style["default"].errMsg
  }, currErrEs)))));
}
var _default = exports["default"] = TopLevelEntityTable;